var map = {
	"./AMEX.svg": "6083",
	"./Maestro.svg": "caae",
	"./Mastercard.svg": "3f6b",
	"./VISA.svg": "dc9b",
	"./V_Pay.svg": "b932",
	"./Visa_Electron.svg": "25fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e2";